module.exports = __webpack_public_path__ + "img/ads.cfb51761.svg";